import PostApiBase from "@/modules/post/services/ApiBase"

export default class Api {
    /*static addImageMulti(q) {
        return PostApiBase.addImageMulti(q).then((resp) => {
            return resp.data["items"]
        })
    }*/

    static deleteImage(q) {
        return PostApiBase.deleteImage(q).then((resp) => {
            return resp.data
        })
    }
}